import { render, staticRenderFns } from "./GeneralLookupResultTable.vue?vue&type=template&id=1fdb4a64&"
import script from "./GeneralLookupResultTable.vue?vue&type=script&lang=js&"
export * from "./GeneralLookupResultTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports